import D2C_ServiceApp from './App'

class D2C_ServiceNginxStatic extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = true
  static order = 13
  static typeName = 'nginxStatic'
  static typeTitle = 'Nginx Static'
  static color = '#008833'
  static methods = {
    ...D2C_ServiceApp.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    configs: {
      ...D2C_ServiceApp.fields.configs,
      default: [
        {name: 'static.conf', text: require('raw-loader!@/assets/configs/nginxStatic-static.conf').default, custom: false},
      ],
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'd2cio/nginx',
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 80},
      ],
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/nginxStatic-hello-world',
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '1.19',
      enum: ['1.16', '1.17', '1.18', '1.19'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/configs', dst: '/etc/nginx/conf.d', sync: false},
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false},
      ],
    },
  }
  get _needRedeploy() {
    return Boolean(this.deployCommands)
  }
}

export default D2C_ServiceNginxStatic
